import * as React from "react";
import { useState } from "react";
import { useFormikContext } from "formik";
import EventProcedureFormFields from "./FormFields";
import NewStepModalFormik from "./NewStepModalFormik";
import StepLibraryFormik from "./StepLibraryFormik";
import EventProcedureStepForm from "../EventProcedureStepForm";
function FormBase() {
  const { values } = useFormikContext();
  const [showNewStepModal, setShowNewStepModal] = useState(false);
  const [showFromLibraryModal, setShowFromLibraryModal] = useState(false);
  const [showViewStepModal, setShowViewStepModal] = useState(false);
  const [stepToView, setStepToView] = useState();
  const handleOnNewStep = () => {
    setShowFromLibraryModal(false);
    setShowViewStepModal(false);
    setShowNewStepModal(true);
  };
  const handleFromLibrary = () => {
    setShowViewStepModal(false);
    setShowNewStepModal(false);
    setShowFromLibraryModal(true);
  };
  const handleViewStep = (stepId) => {
    const selectedStep = values.steps.find(
      (ep) => ep.id === stepId
    );
    setStepToView(selectedStep);
    setShowNewStepModal(false);
    setShowFromLibraryModal(false);
    setShowViewStepModal(true);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    EventProcedureFormFields,
    {
      onNewStep: handleOnNewStep,
      onFromLibrary: handleFromLibrary,
      onViewStep: handleViewStep
    }
  ), showNewStepModal && /* @__PURE__ */ React.createElement(NewStepModalFormik, { onClose: () => setShowNewStepModal(false) }), showFromLibraryModal && /* @__PURE__ */ React.createElement(StepLibraryFormik, { onClose: () => setShowFromLibraryModal(false) }), showViewStepModal && /* @__PURE__ */ React.createElement(
    EventProcedureStepForm,
    {
      eventProcedureStep: stepToView,
      onClose: () => {
        setShowViewStepModal(false);
        setStepToView(void 0);
      },
      readOnly: true
    }
  ));
}
export default FormBase;
